export default "__VITE_ASSET__C8dD36h0__"